import { FC, memo } from 'react';
import { SchedulingDateProps } from './types';
import { StyledSchedulingDate } from './SchedulingDate.css';
import { Text } from '@morf/ui';
import { formatValueDateToDay } from '../../../helpers/formatValueDateToDay';

const SchedulingDate: FC<SchedulingDateProps> = ({
  date,
  isActive,
  isDisabled,
  isHidden,
  isLoading,
  onClick,
}) => {
  const tag = isActive ? 'h4' : 'p1';
  const formattedDate = formatValueDateToDay(date);

  return (
    <StyledSchedulingDate
      data-testid='scheduling-date'
      isActive={isActive}
      isDisabled={isDisabled}
      isHidden={isHidden}
      isLoading={isLoading}
      onClick={onClick}
    >
      <Text tag={tag} color='inherit' align='center'>
        {formattedDate}
      </Text>
    </StyledSchedulingDate>
  );
};

export const MemoizedSchedulingDate = memo(SchedulingDate);
